<!-- <div class="container-fluid d-flex align-items-center justify-content-center mainContainer">
  <div class="row w-100"> -->
    <!-- Left Section -->
    <!-- <div class="col-md-8 d-none d-md-flex align-items-center justify-content-center">
      <img src="assets/loginLeft.png" alt="" class="col-12 loginbgImg">
      <img src="assets/logo_icon.png" alt="" class="logoImg">
    </div> -->
    
    <!-- Right Section -->
    <!-- <div class="col-md-4 col-12 d-flex align-items-center justify-content-center rightSection">
      <div class="login-form w-60">
        <h2 class="fw-bold text-xl">Verify OTP</h2>
        <p class="text-muted mb-4">Enter the 4-digit code sent to your email</p>
        
        <form [formGroup]="otpForm">
          <div class="d-flex justify-content-between gap-1 mb-4">
            <input 
              #otp1
              type="text" 
              class="form-control text-center  fs-4"
              maxlength="1"
              formControlName="digit1"
              (keyup)="onDigitInput($event, otp1, otp2)"
              (keydown)="onKeyDown($event)"
              autocomplete="off"
            />
            <input 
              #otp2
              type="text" 
              class="form-control text-center  fs-4"
              maxlength="1"
              formControlName="digit2"
              (keyup)="onDigitInput($event, otp2, otp3, otp1)"
              (keydown)="onKeyDown($event)"
              autocomplete="off"
            />
            <input 
              #otp3
              type="text" 
              class="form-control text-center  fs-4"
              maxlength="1"
              formControlName="digit3"
              (keyup)="onDigitInput($event, otp3, otp4, otp2)"
              (keydown)="onKeyDown($event)"
              autocomplete="off"
            />
            <input 
              #otp4
              type="text" 
              class="form-control text-center  fs-4"
              maxlength="1"
              formControlName="digit4"
              (keyup)="onDigitInput($event, otp4, null, otp3)"
              (keydown)="onKeyDown($event)"
              autocomplete="off"
            />
          </div>

          <div *ngIf="showError" class="text-danger text-center mb-3">
            {{ errorMessage }}
          </div>
          
          <button 
            type="button" 
            class="btn btn-primary w-100 py-2 mb-3"
            (click)="verifyOtp()"
          >
            Verify OTP
          </button>
          
          <div class="text-center">
            <span class="text-muted">Didn't receive code? </span>
            <a class="text-purple cursor-pointer" (click)="resendOtp()" [class.disabled]="isResending" [style.pointer-events]="isResending ? 'none' : 'auto'">
              <span *ngIf="isResending" class="spinner-border spinner-border-sm me-1" style="width: 0.7rem; height: 0.7rem;" role="status" aria-hidden="true"></span>
              {{ isResending ? 'Resending...' : 'Resend OTP' }}
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div> -->






<div class="maindiv flex items-center justify-center min-h-screen bg-cover bg-center" style="background-image: url('assets/newui/background.png');">
  <div class="bg-white formcontainer shadow-lg p-4 sm:p-8 md:p-12 w-full max-w-md mx-4">
    <h2 class="text-xl sm:text-2xl font-semibold text-center mb-2">Verify OTP</h2>
    <p class="text-center text-gray-600 text-xs sm:text-sm mb-4">Enter the 4-digit code sent to your email</p>
    <form [formGroup]="otpForm">
      <div class="flex justify-between gap-1 sm:gap-2 mb-4">
        <input 
          #otp1
          type="text" 
          class="form-control text-center fs-4 w-full h-12 sm:h-14"
          maxlength="1"
          formControlName="digit1"
          (keyup)="onDigitInput($event, otp1, otp2)"
          (keydown)="onKeyDown($event)"
          autocomplete="off"
          inputmode="numeric"
        />
        <input 
          #otp2
          type="text" 
          class="form-control text-center fs-4 w-full h-12 sm:h-14"
          maxlength="1"
          formControlName="digit2"
          (keyup)="onDigitInput($event, otp2, otp3, otp1)"
          (keydown)="onKeyDown($event)"
          autocomplete="off"
          inputmode="numeric"
        />
        <input 
          #otp3
          type="text" 
          class="form-control text-center fs-4 w-full h-12 sm:h-14"
          maxlength="1"
          formControlName="digit3"
          (keyup)="onDigitInput($event, otp3, otp4, otp2)"
          (keydown)="onKeyDown($event)"
          autocomplete="off"
          inputmode="numeric"
        />
        <input 
          #otp4
          type="text" 
          class="form-control text-center fs-4 w-full h-12 sm:h-14"
          maxlength="1"
          formControlName="digit4"
          (keyup)="onDigitInput($event, otp4, null, otp3)"
          (keydown)="onKeyDown($event)"
          autocomplete="off"
          inputmode="numeric"
        />
      </div>

      <div *ngIf="showError" class="text-danger text-center text-sm mb-3">
        {{ errorMessage }}
      </div>
      
      <button 
        type="button" 
        class="btn btn-primary w-full py-2 sm:py-3 mb-3 text-sm sm:text-base"
        (click)="verifyOtp()"
      >
        Verify OTP
      </button>
      
      <div class="text-center text-sm">
        <span class="text-muted">Didn't receive code? </span>
        <a class="text-purple cursor-pointer" (click)="resendOtp()" [class.disabled]="isResending" [style.pointer-events]="isResending ? 'none' : 'auto'">
          <span *ngIf="isResending" class="spinner-border spinner-border-sm me-1" style="width: 0.7rem; height: 0.7rem;" role="status" aria-hidden="true"></span>
          {{ isResending ? 'Resending...' : 'Resend OTP' }}
        </a>
      </div>
    </form>
  </div>
</div>